import React, { useEffect, useRef, useState } from "react";
import "./Products.css";
import juteImg from "../asset/35187.jpg";
import totagImg from "../asset/IN_Premium-Tote-Bags_Hero-image_01.jpg";
import canvasImg from "../asset/71mgmQmgPjL._AC_UY350_.jpg";

const Products: React.FC = () => {
  const textRef = useRef<HTMLParagraphElement>(null);
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setAnimate(true);
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.3 }
    );

    if (textRef.current) {
      observer.observe(textRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section className="products" id="about">
      
      <div className="products-header">
        <div>
          <p className="small-title">— Our Products</p>
          <h2>
            Durable Bags That <br />
            Drive Your Business Forward
          </h2>
        </div>

        <div className="products-text">
          <p ref={textRef} className={animate ? "animate" : ""}>
            Get Natural Jute, Sturdy Canvas, and Durable Nylon Bags Directly from the Manufacturer.
            Supplying Across India from New Delhi.
          </p>

          <div className="product-buttons">
            <button className="btn-green">Call for bulk orders</button>
            <button className="btn-light">Contact for custom designs</button>
          </div>
        </div>
      </div>

      <div className="product-grid">

        <div className="card">
          <img src={juteImg} alt="Jute Bags" />
          <h3>Natural Jute Bags</h3>
          <p>Eco-friendly and durable bags perfect for daily and bulk usage.</p>
        </div>

        <div className="card">
          <img src={totagImg} alt="Canvas" />
          <h3>Custom Logo Printing</h3>
          <p>High-quality printing solutions for branding and business needs.</p>
        </div>

        <div className="card">
          <img src={canvasImg} alt="Canvas Bags" />
          <h3>Strong Canvas Options</h3>
          <p>Premium canvas bags built for strength and long-term use.</p>
        </div>

        <div className="card">
          <img src={juteImg} alt="Pouch" />
          <h3>Flexible Pouch Bags</h3>
          <p>Compact and stylish pouch bags for versatile applications.</p>
        </div>

        <div className="card">
          <img src={juteImg} alt="Factory" />
          <h3>Direct Factory Pricing</h3>
          <p>Affordable pricing directly from our manufacturing unit.</p>
        </div>

        <div className="card">
          <img src={juteImg} alt="Delivery" />
          <h3>Pan India Delivery</h3>
          <p>Fast and reliable delivery service across India.</p>
        </div>

      </div>

    </section>
  );
};

export default Products;